// 菜单路由
const Dashboard = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/index')), reject, 'page-base') // 首页仪表盘
const Shopwxshop = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/shop/wxshop')), reject, 'page-base') // 微信门店管理
const Wxshopsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/shop/shopsetting')), reject, 'page-base') // 门店信息配置
const Comments = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/shop/comments')), reject, 'page-base') // 门店评论
const Assetpayment = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/payment')), reject, 'page-base') // 微信支付账户配置
const Assetaccountactivation = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/asset/accountactivation/index')), reject, 'page-base') // 订购续费
const Datamessage = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/shortmessage/index')), reject, 'page-base') // 短信账户
const Staffleader = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/shopstaff/salesperson/leaderlist')), reject, 'page-base') // 门店管理员
const Accountmanagement = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/account/management')), reject, 'page-base') // 平台管理员 --
const Accountroles = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/account/roles')), reject, 'page-base') // 角色管理 --
const Basearticle = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/article/index')), reject, 'page-base') // 文章管理
const Basecurrency = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/currency/index')), reject, 'page-base') // 货币管理
const Baseexport = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/exportlog/index')), reject, 'page-base') // 日志导出
const Brand = (resolve, reject) => require.ensure([], () => resolve(require('../view/brand/wechat/open')), reject, 'page-brand') // 公众号授权
const Brandcustomer = (resolve, reject) => require.ensure([], () => resolve(require('../view/brand/wechat/customservice')), reject, 'page-brand') // 公众号客服管理
const Brandmenu = (resolve, reject) => require.ensure([], () => resolve(require('../view/brand/wechat/custommenu')), reject, 'page-brand') // 自定义公众号菜单
const Brandreply = (resolve, reject) => require.ensure([], () => resolve(require('../view/brand/wechat/reply')), reject, 'page-brand') // 公众号消息自动回复设置
const Brandfans = (resolve, reject) => require.ensure([], () => resolve(require('../view/brand/wechat/fans')), reject, 'page-brand') // 公众号粉丝管理
const Brandmaterial = (resolve, reject) => require.ensure([], () => resolve(require('../view/brand/wechat/aterialmanagement')), reject, 'page-brand') // 素材管理
const Goodscategory = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/category')), reject, 'page-mall-goods') // 商品分类
const Goodsmaincategory = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/maincategory')), reject, 'page-mall-goods') // 商品分类
const Servicegoods = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/service/index')), reject, 'page-mall-goods') // 服务类商品管理
const Courseresources = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/course/CourseResources')), reject, 'page-mall-goods') // 课程资源
const Goodsphysical = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/list')), reject, 'page-mall-goods') // 实体类商品
const Goodslease = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/lease/list')), reject, 'page-mall-goods') // 租赁商品
const Physicalupload = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/normalGoodsUpload')), reject, 'page-mall-goods') // 实体商品导入
const Tagsupload = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/normalGoodsTags')), reject, 'page-mall-goods') // 实体商品标签导入
const Physicalstoreupload = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/normalGoodsStoreUpload')), reject, 'page-mall-goods') // 实体商品库存导入
const Physicalprofitupload = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/normalGoodsProfitUpload')), reject, 'page-mall-goods') // 实体商品分润导入
const Goodsbrand = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/attributes/brand')), reject, 'page-mall-goods') // 商品品牌管理
const Arrivalnotice = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/subscribe/goods/list')), reject, 'page-member') // 到货通知
const Servicepayment = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/list')), reject, 'page-mall-trade') // 交易单管理
const Tradeservice = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/list')), reject, 'page-mall-trade') // 服务订单管理
const Tradenormalorders = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/normalorders/list')), reject, 'page-mall-trade') // 实物订单管理
const Tradenormalshoporders = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/normalorders/shopList')), reject, 'page-mall-trade') // 自营订单管理
const Leasetrade = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/lease/list')), reject, 'page-mall-trade')  //  租赁订单
const Leasetrade_aftersales = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/lease/afterSalesDetail')), reject, 'page-mall-trade')
const Tradedrugorders = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/normalorders/drugList')), reject, 'page-mall-trade') // 药品需求单
const Tradepayment = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/list')), reject, 'page-mall-trade') // 交易单管理
const Tradeverification = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/salesmanWorkRecords')), reject, 'page-mall-trade') // 服务核销单
// import Shippingtemplates from '../view/mall/trade/shipping/templates' // 运费模版
const Supplier = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/supplier/list')), reject, 'page-mall-trade')   // 供应商列表
const Shippingtemplates = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/shipping/templates')), reject, 'page-mall-trade')  // 运费模版

const Marketingdistributor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributor')), reject, 'page-mall-marketing') // 店铺管理
const Marketingdistributor_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributor_editor')), reject, 'page-mall-marketing') // 店铺编辑Marketing
const Marketingdistributor_template = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributor_template')), reject, 'page-mall-marketing') // 店铺编辑Marketing
const Marketingdistribution_orders = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributionOrders')), reject, 'page-mall-marketing') // 店铺订单
const Distributortags = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributortags')), reject, 'page-mall-marketing') // 商品标签
const Distributorrel_items = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributorRelItems')), reject, 'page-mall-marketing') // 店铺关联商品
// import Distributoraftersalesaddress from '../view/mall/marketing/distributorAftersalesAddress' //店铺售后地址
const Distributorinvoice = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributorInvoice')), reject, 'page-mall-marketing') // 店铺发票
const Marketinglog = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributionLog')), reject, 'page-mall-marketing') // 店铺记录
const ShopDecoration = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/shopDecoration')), reject, 'page-mall-marketing') // 微商城店铺装修
const DistributorCode = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributorCode')), reject, 'page-mall-marketing') // 微商城店铺装修
const Marketingsalesman = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/salesman')), reject, 'page-guide') // 导购员管理
const Marketingsalesmanrole = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/salemanRoleConfig')), reject, 'page-guide') // 导购员管理
const ShoppingGuideTask = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shoppingGuideTask')), reject, 'page-guide') // 导购任务
const ShoppingGuideTask_statistics = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shoppingGuideTaskStatistics')), reject, 'page-guide') // 导购任务统计
const Shoppingguidenotification = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shoppingguidenotification')), reject, 'page-guide') // 导购员管理
const Salemancustomercomplaints = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/salemanCustomerComplaints')), reject, 'page-guide') // 导购员客诉管理
const SalemanLoginHistory = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/SalemanLoginHistory')), reject, 'page-guide') // 导购员登录记录
const SalesmanRelationship = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/salesman_relationship')), reject, 'page-guide') // 导购会员关系
const Shopactivities = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shopactivities')), reject, 'page-guide') // 导购知识库
const Shopnoticetempl = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shopnoticetempl')), reject, 'page-guide') // 导购消息模版
const Reservationsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/reservation/setting/index')), reject, 'page-mall-reservation') // 预约设置
const Mallreservation = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/reservation/resourcesetting/index')), reject, 'page-mall-reservation') // 预约管理
const Reservationorder = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/reservation/resourcesetting/reservation')), reject, 'page-mall-reservation') // 预约单
const Mallrecharge = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/storeddeposit/index')), reject, 'page-mall-storeddeposit') // 会员账户储值
const Aftersaleslist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/aftersales/list')), reject, 'page-mall-aftersales') // 售后单管理
const Aftersalesrefundlist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/aftersales/refundList')), reject, 'page-mall-aftersales') // 退款单管理
const Aftersalesrefundlist_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/aftersales/refundDetail')), reject, 'page-mall-aftersales') // 退款单详情
const Fapiaolist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/fapiao/list')), reject, 'page-mall-fapiao') //发票列表
const Fapiao_set = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/fapiao/set')), reject, 'page-mall-fapiao') // 发票设置
const Fapiao_set_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/fapiao/add')), reject, 'page-mall-fapiao') //添加发票
const Member = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/list')), reject, 'page-member') // 会员管理
const Manageinfomation = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/registersetting/index')), reject, 'page-member') // 会员注册信息
const Managecard = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/membercard/index')), reject, 'page-member') // 会员卡与等级设置
const Managecardorder = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/membercard/list')), reject, 'page-member') // 会员卡购买记录
const Managecustomer = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/uploade')), reject, 'page-member') // 会员信息导入 **
const Managetag = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/tags')), reject, 'page-member') // 会员标签
const Analysisrights = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/rightsList')), reject, 'page-member') // 会员权益管理
const AnalysisrightsContent = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/analysisrightsContent')), reject, 'page-member') // 会员权益管理
const MemberMerge = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/merge')), reject, 'page-member') // 会员帐号合并
// import Membermarketing_luckyDraw from '../view/member/cardticket/luckyDraw' // 抽奖活动管理
const Membermarketing = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/cardticket/coupon')), reject, 'page-member') // 优惠券管理
const CouponAutosend = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/cardticket/autosend')), reject, 'page-member') // 优惠券自动派发
const Couponsend = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/cardticket/couponSend')), reject, 'page-member') // 群发优惠券，与会员管理同一组件
const Smssend = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/list')), reject, 'page-member') // 群发短信，与会员管理同一组件
const Coupongive = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/coupon/giveLog')), reject, 'page-member') // 优惠券后台发放记录
const Coupongrantset = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/cardticket/couponGrantSet')), reject, 'page-member')  //优惠券发放管理设置
const Marketingindex = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/index')), reject, 'page-member') // 注册营销
const Marketingbargain = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/bargain/index')), reject, 'page-member') // 微信助力
const Marketingactivity = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/activity/index')), reject, 'page-member') // 自动化营销
const Groupsindex = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/groups/index')), reject, 'page-member') // 拼团活动管理
const Popularizesetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/setting')), reject, 'page-popularize') // 分销设置
const Promotersetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/promoterSetting')), reject, 'page-popularize') // 代理商等级设置
const Popularizelist = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/list')), reject, 'page-popularize') // 代理商列表
const Popularizeorder = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/order')), reject, 'page-popularize') // 代理商订单
const Popularizepurchaseorder = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/purchaseOrder')), reject, 'page-popularize') // 代理商采购订单
const Popularizepurchaseorder_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/purchaseOrderDetail')), reject, 'page-popularize') // 代理商采购订单详情
const Popularizelist_stock = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/stockManage')), reject, 'page-popularize')
const Popularizelist_incomeDetail = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/incomeDetail')), reject, 'page-popularize')
const Popularizedata = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/data')), reject, 'page-popularize') // 代理商列表
const Popularizewithdraw = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/withdraw')), reject, 'page-popularize') // 分销提现
const Popularizegoods = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/goods')), reject, 'page-popularize') // 推广商品
const PopularizegoodsAudit = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/goodsAudit')), reject, 'page-popularize') // 推广商品审核
const Taskbrokerage = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/taskBrokerage')), reject, 'page-popularize') // 任务佣金明细
const Taskbrokeragecount = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/taskBrokerageCount')), reject, 'page-popularize') // 任务佣金统计
const Marketingcommunity = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/index')), reject, 'page-member') // 社区管理
const Marketingcommunityactivity = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/activity/index')), reject, 'page-member') // 活动管理
const Marketingdeliveryorder = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/deliveryorder')), reject, 'page-member') // 配送单
const Communitysetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/setting')), reject, 'page-member') // 社区活动设置
const Communitywithdraw = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/withdraw')), reject, 'page-member') // 积分提现
const Communityactivityorder = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/activity/orderList')), reject, 'page-member') // 社区活动订单
const Marketingseckill = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/seckill/list')), reject, 'page-member') // 秒杀活动管理
const Limitedtimesale = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/limitedtimesale/list')), reject, 'page-member') // 限时特惠活动管理
const Goodslimit = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/goodslimit/list')), reject, 'page-member') // 商品限购管理
const Wxapp = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/index')), reject, 'page-wxapp') // 小程序列表
const Templateedit = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/management')), reject, 'page-wxapp') // 小程序模板编辑
const Coursetemplate = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/CourseTemplate')), reject, 'page-wxapp') // 课程模板
const Batemplateedit = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/bamanagement')), reject, 'page-wxapp') // ba小程序模板编辑
const Pctemplate = (resolve, reject) => require.ensure([], () => resolve(require('../view/pc/homePage/default')), reject, 'page-pc') // pc首页模板编辑
const Pcviptemplate = (resolve, reject) => require.ensure([], () => resolve(require('../view/pc/vipPage/default')), reject, 'page-pc') // pc vip页面模板编辑
const Pcfootertext = (resolve, reject) => require.ensure([], () => resolve(require('../view/pc/footerPage/default')), reject, 'page-pc') // pc 底部文案
const Tdkglobalset = (resolve, reject) => require.ensure([], () => resolve(require('../view/pc/tdk/globalset')), reject, 'page-pc') // Tdk全局设置
const Tdkgivenset = (resolve, reject) => require.ensure([], () => resolve(require('../view/pc/tdk/givenset')), reject, 'page-pc') // Tdk全局设置
const Pccustompage = (resolve, reject) => require.ensure([], () => resolve(require('../view/pc/custompage')), reject, 'page-pc') // pc 自定义页面
const Editcategory = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/category')), reject, 'page-wxapp') // 自定义小程序分类
const Custompage = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/custompage')), reject, 'page-wxapp') // 自定义小程序页面
const Customlink = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/customlink')), reject, 'page-wxapp') // 自定义小程序链接
const Floorguide = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/floor_guide')), reject, 'page-wxapp') // 自定义楼层引导页面
const Colorstyle = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/color_style')), reject, 'page-wxapp') // 自定义楼层引导页面
const Cartremind = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/cartremindmanagement')), reject, 'page-wxapp') // 小程序购物车提醒
const Membercentersetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/member_center_setting')), reject, 'page-wxapp') //会员中心设置
const Itemsdetailsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/items_detail_setting')), reject, 'page-wxapp') // 商品详情设置
const OpenscreenadNew = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/openScreenadNew')), reject, 'page-wxapp') // 开屏广告
const Editdashboard = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/statistics/dataanalysis/index')), reject, 'page-wxapp') // 小程序数据分析
const Editsourcemanagement = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/statistics/sourcemanagement/index')), reject, 'page-wxapp') // 小程序千人千码
const Editauthorize = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/authorize/index')), reject, 'page-wxapp') // 小程序授权
const Marketingsfulldiscount = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/fulldiscount/list')), reject, 'page-member') // 满折活动列表
const Marketingsfullminus = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/fullminus/list')), reject, 'page-member') // 满减活动列表
const Marketingsfullgift = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/fullgift/list')), reject, 'page-member') // 满赠活动列表
const Marketingspluspricebuy = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/pluspricebuy/list')), reject, 'page-member') // 加价购活动列表
const Marketingpackage = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/package/list')), reject, 'page-member') // 组合促销促销
const Wheel = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/wheel/index')), reject, 'page-member') // 大转盘抽奖
const Ordersetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/ordersetting')), reject, 'page-mall-trade') // 订单时效配置
const Goodsattributes = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/attributes/attributes')), reject, 'page-mall-goods') // 商品规格列表
const Goodsparams = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/attributes/params')), reject, 'page-mall-goods') // 商品参数列表
const Storeshopitemanagement = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/storeshop/itemlist')), reject, 'page-mall-storeshop') // 店铺商品列表
const Merchantstaff = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/account/storestaff')), reject, 'page-base') // 商城（店铺）员工管理
const Merchantstaffroles = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/account/storeroles')), reject, 'page-base') // 商城（店铺）员工角色管理
const Platformstaff = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/account/normalstaff')), reject, 'page-base') // 平台员工管理
const Platformstaffroles = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/account/normalroles')), reject, 'page-base') // 平台员工角色管理
const Planting = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/planting/index')), reject, 'page-base') // 种草列表
const Articlecolumns = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/article/columns')), reject, 'page-base') // 文章栏目
const Articlegeneralcolumns = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/article/generalcolumns')), reject, 'page-base') // 文章栏目

const Playbackcolumns = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/playback/playbackcolumns')), reject, 'page-base') // 回放栏目
const Playback = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/playback/playback')), reject, 'page-base') // 回放管理

const Operatorlogs = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/companys/logs')), reject, 'page-base') // 商家操作日志列表

const Itemtags = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/tags')), reject, 'page-mall-goods') // 商品标签
const Goodsaudit = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/audit/list')), reject, 'page-mall-goods') // 商品标签
const Goodsaudit_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/audit/add')), reject, 'page-mall-goods') // 商品标签

const Selfdeliveryaddress = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/address/setting')), reject, 'page-base') // 设置固定自提地址
const Distributoraftersalesaddress = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/distributorAftersalesAddress')), reject, 'page-mall-marketing') //店铺售后地址

const Ordercartsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/cartadsetting')), reject, 'page-mall-trade') // 购物车广告营销语

const Recommendlike = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/recommendlike')), reject, 'page-member') // 设置固定自提地址

const Omsqueuelog = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/omsqueuelog')), reject, 'page-mall-trade') // 查看oms通信日志

const Refunderrorlogs = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/refunderrorlogs')), reject, 'page-mall-trade') // 退款错误日志

const Rate = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/rate/list')), reject, 'page-mall-trade') // 订单评价

const Certificate = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/certificate/index')), reject, 'page-base') // 授权

const DataAnalysis = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/dataAnalysis')), reject, 'page-base') // 数据分析配置

// import Basic_setting from '../view/mall/marketing/basicSetting' // 基础配置
// import Onecode from '../view/brand/codegoods/thingslist' // 商品码管理
// import Things from '../view/brand/codegoods/thingsedit' // 新增编辑物品
// import Batchs from '../view/brand/codegoods/batchsedit' // 批次管理&&新增编辑批次
// import Thingsbatchs_detail from '../view/brand/codegoods/thingsbatchsdetail' //物品批次详情
// import Withdraw from '../view/mall/marketing/withdraw' // 提现申请
// import Surveillance from '../view/mall/marketing/surveillance' // 店铺二维码
// import Distributorlog from '../view/mall/marketing/logByDistributor' // 商家店铺记录
// import List from '../view/mall/reservation/resourcesetting/list' // 资源位管理
// import registerRromotionsAdd from '../view/member/promotions/distributorEdit'

const Selformelementsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/formsettinglist')), reject, 'page-member')   // 自助表单元素配置
const Selformtempsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/formtemplatelist')), reject, 'page-member')     // 自助表单模板配置
// import Physicalmeasurement_detail from '../view/member/selfservice/userdaliyrecord'   // 用户体测详情报表
const Physicalmeasurement = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/templatepreview')), reject, 'page-member')     // 用户体测列表和配置

const Rankingrule = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/rankingrule/list')), reject, 'page-member') // 榜单管理
const Rankingrule_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/rankingrule/add')), reject, 'page-member') // 新增编辑榜单

/***********member tag category begin*************/
const Membertagcategory = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/tagcategory.vue')), reject, 'page-member')     // 用户体测列表和配置
/***********member tag category end*************/
/***********新的门店 begin*************/
const Distributorshops = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/shops/lists')), reject, 'page-mall-marketing') // 店铺管理
const Distributorshops_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/shops/edit')), reject, 'page-mall-marketing') // 店铺管理
/***********新的门店 end*************/

const Registrationactivity = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/registrationactivity')), reject, 'page-member')     // 报名活动管理
const Registrationactivity_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/registrationactivityadd')), reject, 'page-member')     // 报名活动管理
const Registrationrecord = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/registrationrecord')), reject, 'page-member')     // 报名记录管理
const Registrationrecord_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/registrationrecordetail')), reject, 'page-member')     // 报名记录管理
const Registrationrecord_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/regRecordUpload')), reject, 'page-member')    //报名审核结果上传日志

const Specificcrowddiscount = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/specificcrowd/specificcrowddiscount')), reject, 'page-member')  //定向促销
const Specificcrowddiscount_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/specificcrowd/userdiscoutlog')), reject, 'page-member')  //定向促销促销详情

const Weburlsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/weburlsetting')), reject, 'page-base')  //外部链接配置
const Autorecharge = (resolve, reject) => require.ensure([], () => resolve(require('../view/deposit/autorecharge')), reject, 'page-deposit')  // 福卡充值配置
const Autorechargerecord = (resolve, reject) => require.ensure([], () => resolve(require('../view/deposit/autorechargerecord')), reject, 'page-deposit')  // 福卡充值记录

const Retailer = (resolve, reject) => require.ensure([], () => resolve(require('../view/retailer/list')), reject, 'page-retailer') // 分销员列表
const Retailer_incomeDetail = (resolve, reject) => require.ensure([], () => resolve(require('../view/retailer/incomeDetail')), reject, 'page-retailer') // 分销员收入详情
const Retailergoods = (resolve, reject) => require.ensure([], () => resolve(require('../view/retailer/goods')), reject, 'page-retailer') // 分销商品
const Retailerorders = (resolve, reject) => require.ensure([], () => resolve(require('../view/retailer/orders')), reject, 'page-retailer') // 分销订单

// 隐藏路由
import Home from '../view/home' // 主框架
import Layout from '../view/layout' // 主结构
const Authloading = (resolve, reject) => require.ensure([], () => resolve(require('../view/authloading')), reject, 'page-authloading') // 绑定微信
const Shopwxshop_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/shop/editshop')), reject, 'page-base') // 添加修改门店
const Basearticle_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/article/editor')), reject, 'page-base') // 添加编辑文章
const Brandmaterial_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/brand/wechat/artical/new_artical')), reject, 'page-brand') // 新增编辑图文消息
const Servicegoods_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/service/items/add')), reject, 'page-mall-goods') // 服务类商品添加编辑
const Goodsphysical_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/add')), reject, 'page-mall-goods') // 实体类商品添加编辑
const Goodslease_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/lease/add')), reject, 'page-mall-goods') // 租赁商品添加编辑
const Tradenormalorders_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/detail')), reject, 'page-mall-trade') // 实体订单详情
const Tradenormalorders_process = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/process')), reject, 'page-mall-trade') // 实体订单详情
const Tradenormalshoporders_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/detail')), reject, 'page-mall-trade') // 自营订单详情
const Leasetrade_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/lease/detail')), reject, 'page-mall-trade') // 租赁订单详情
const Tradedrugorders_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/detail')), reject, 'page-mall-trade') // 药品需求单订单详情
const Marketingdistribution_orders_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/detail')), reject, 'page-mall-trade') // 店铺订单详情
const Tradeservice_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/detail')), reject, 'page-mall-trade') // 服务订单详情
const Shippingtemplates_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/shipping/add')), reject, 'page-mall-trade') // 添加编辑运费模板
const Mallreservation_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/reservation/resourcesetting/add')), reject, 'page-mall-reservation') // 资源位添加
const Coupongive_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/coupon/giveErrorLog')), reject, 'page-member') // 优惠券后台发放记录详情
const Aftersaleslist_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/aftersales/detail')), reject, 'page-mall-aftersales') // 售后单详情
const Fapiaolist_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/fapiao/detail')), reject, 'page-mall-fapiao') //发票编辑
const Member_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/detail')), reject, 'page-member') // 会员详情页
const Membermarketing_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/cardticket/detail')), reject, 'page-member') // 优惠券领取记录
const Membermarketing_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/cardticket/edit')), reject, 'page-member') // 添加编辑优惠券
const Marketingbargain_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/bargain/add')), reject, 'page-member') // 添加编辑微信助力
const Marketingactivity_templ = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/activity/templ')), reject, 'page-member') // 自动化营销选择模版
const Marketingactivity_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/activity/add')), reject, 'page-member') // 新增自动化营销
const Marketingactivity_update = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/activity/edit')), reject, 'page-member') // 编辑自动化营销
const Groupsindex_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/groups/add')), reject, 'page-member') // 新增编辑拼团活动
const Groupsindex_team = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/groups/team')), reject, 'page-member') // 拼团活动数据
const Groupsindex_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/groups/teamDetail')), reject, 'page-member') // 拼团活动团详情
const Popularizelist_child = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/children')), reject, 'page-popularize') // 代理商直属下级
const Popularizelist_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/popularize/brokerageLog')), reject, 'page-popularize') // 代理商佣金详情
const Marketingcommunity_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/points')), reject, 'page-member') // 社区积分
const Marketingcommunity_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/add')), reject, 'page-member') // 新增编辑社区
const Marketingcommunityactivity_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/activity/add')), reject, 'page-member') // 新增编辑活动
const Communityactivityorder_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/order/detail')), reject, 'page-mall-trade') // 社区活动订单详情
const Marketingseckill_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/seckill/add')), reject, 'page-member') // 新增编辑秒杀活动
const Limitedtimesale_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/limitedtimesale/add')), reject, 'page-member') // 新增编辑限时特惠活动
const Goodslimit_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/goodslimit/add')), reject, 'page-member') // 新增商品限购
const Editsourcemanagement_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/statistics/sourcemanagement/monito_detail')), reject, 'page-wxapp')
const Marketingsfulldiscount_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/fulldiscount/add')), reject, 'page-member')  // 添加编辑满折活动
const Marketingsfullminus_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/fullminus/add')), reject, 'page-member')      // 添加编辑满减活动
const Marketingsfullgift_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/fullgift/add')), reject, 'page-member') // 添加编辑满赠活动
const Marketingpackage_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/package/add')), reject, 'page-member') // 组合促销促销
const Wxapp_templ = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/template')), reject, 'page-wxapp') // 开通小程序模板
const Marketingdeliveryorder_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/community/deliverydetail')), reject, 'page-member') // 配送单详情
const Marketingspluspricebuy_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/pluspricebuy/add')), reject, 'page-member') // 加价购活动编辑
const Shopexerp = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/shopexerp')), reject, 'page-base') // 商派erp直连配置
const Planting_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/planting/editor')), reject, 'page-base') // 添加编辑种草
const Admininfo = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/shop/admininfo')), reject, 'page-base') // 管理员信息
const Yilianyun = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/yilianyun/index')), reject, 'page-base') // 管理员信息
const Tradesetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/tradesetting/index')), reject, 'page-base') // 管理员信息
const Meiqia = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/im/list')), reject, 'page-base') // 管理员信息
const Echat = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/im/echat')), reject, 'page-base') // 一洽配置信息
const Fapiaosetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/fapiao/list')), reject, 'page-base') // 发票配置
const AddressBook = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/addressBook/index')), reject, 'page-base') // 企业微信通讯录
const Pointrule = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/point/index.vue')), reject, 'page-member') // 管理员信息
const Pointoverview = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/point/overview.vue')), reject, 'page-member') // 积分总览

const Selformelementsetting_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/formsettingadd')), reject, 'page-member')   // 自助表单元素配置
const Selformtempsetting_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/formtemplateadd')), reject, 'page-member')     // 自助表单模板配置
const Physicalmeasurement_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/selfservice/userdaliyrecord')), reject, 'page-member')   // 用户体测详情报表
const Couponsend_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/members/detail')), reject, 'page-member') // 群发优惠券会员详情页
const Shoppingguidenotification_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shoppingguidenotification_editor')), reject, 'page-guide') // 导购员管理 编辑
const ShoppingGuideTask_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shoppingGuideTask_editor')), reject, 'page-guide') // 新增编辑导购任务
const Shopactivities_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/guide/shopActivities_editor')), reject, 'page-guide') // 导购知识库 编辑

// 店铺端页面
const Shopstorelist = (resolve, reject) => require.ensure([], () => resolve(require('../view/shop/storelist')), reject, 'page-shop') // 门店列表
const Shopstorelist_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/shop/editstore')), reject, 'page-shop') // 门店编辑
const Companygoods = (resolve, reject) => require.ensure([], () => resolve(require('../view/shop/goods/companygoods')), reject, 'page-shop') // 门店编辑
const Memberstatistics = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/datacube/companydata/member')), reject, 'page-mall-datacube') // 商城统计信息-会员
const Orderstatistics = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/datacube/companydata/order')), reject, 'page-mall-datacube') // 商城统计信息-订单
const Distributordata = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/datacube/distributordata')), reject, 'page-mall-datacube') // 商城统计信息-订单
const Hotkeywords = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/hotkeywords')), reject, 'page-mall-goods') // 热门关键词
const Goodsstatistics = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/datacube/goodsdata')), reject, 'page-mall-datacube') // 商品统计信息
const Salesmonitoring = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/datacube/SalesMonitoring')), reject, 'page-mall-datacube') // 销售监控面板
const Salesmonitoring_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/datacube/SalesMonitoringDetail')), reject, 'page-mall-datacube') // 销售监控面板详情

const Logistics = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/logistics')), reject, 'page-mall-trade')
const Noticemessage = (resolve, reject) => require.ensure([], () => resolve(require('../view/wxapp/messages')), reject, 'page-wxapp') // 查看oms通信日志

const Kdniao = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/kdniao')), reject, 'page-base') // 快递配置
const Sfbsp = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/sfbsp')), reject, 'page-base') // 快递配置

const Workwechat = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/workwechat/workwechat')), reject, 'page-base')
const WorkwechatTagScript = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/workwechat/tagScript')), reject, 'page-base')
const WorkwechatTagScript_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/workwechat/tagScript_editor')), reject, 'page-base')
const WorkwechatTagScript_data = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/workwechat/tagScript_data')), reject, 'page-base')
const DistributionConfig = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/distribution/index')), reject, 'page-base')
const Wxaindex = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/wxa/index')), reject, 'page-base')
const Profitlist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/profit/list')), reject, 'page-mall-profit') // 交易单管理
const Publicsetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/publicsetting')), reject, 'page-base')     //公共配置页面
const Sharesetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/setting/sharesetting')), reject, 'page-base')     //分享页面
const Liveroomlist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/liveroom/list')), reject, 'page-mall-liveroom') // 直播间列表
// import Liveroomlist_editor from '../view/mall/liveroom/replay' //直播间视频回放列表
const Liveroomlist_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/liveroom/tutorDetail')), reject, 'page-mall-liveroom') //导师直播间详情
const Liveroomlist_goodsstore = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/liveroom/liveGoodsStore')), reject, 'page-mall-liveroom') // 直播间商品库
const Laijianlivinglist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/laiJianLivingList')), reject, 'page-mall-marketing') //来见直播列表
const PosterActivity = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/posterActivity')), reject, 'page-mall-marketing') //海报营销
const LuckydrawProb = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/luckydrawProb')), reject, 'page-mall-marketing') //抽奖活动
const Giftcard = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/giftcard')), reject, 'page-mall-marketing') // 实体卡券
const CheckinActivity = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/checkin/index')), reject, 'page-member') // 签到活动
const CheckinActivity_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/promotions/checkin/add')), reject, 'page-member') // 新增编辑签到活动

const Normalordersupload = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/normalorders/ordersupload')), reject, 'page-mall-trade') // 实体订单导入列表

// 跨境
const Origincountry = (resolve, reject) => require.ensure([], () => resolve(require('../view/crossborder/origincountry/list')), reject, 'page-crossborder') // 产地国
const Crossbordersetinfo = (resolve, reject) => require.ensure([], () => resolve(require('../view/crossborder/crossborderset/info')), reject, 'page-crossborder') // 跨境设置
const Godsphysicalkj = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/list')), reject, 'page-mall-goods') // 实体类商品
const Godsphysicalkj_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/physical/add')), reject, 'page-mall-goods') // 实体类商品添加编辑
const Taxstrategy = (resolve, reject) => require.ensure([], () => resolve(require('../view/crossborder/taxstrategy/list')), reject, 'page-crossborder')// 跨境税率策略列表
const Taxstrategy_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/crossborder/taxstrategy/edit')), reject, 'page-crossborder')// 跨境税率策略详情

const Financialaftersaleslist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/aftersales/financial/list')), reject, 'page-mall-aftersales') // 财务-售后列表
const Salesreportlist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/financial/list')), reject, 'page-mall-trade') // 财务-销售报表
const Salesorderslist = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/trade/financial/SalesOrdersList')), reject, 'page-mall-trade') // 财务-销售订单
const Whitelistlist = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/whitelist/list')), reject, 'page-member') // 会员-白名单
const Whitelistuploade = (resolve, reject) => require.ensure([], () => resolve(require('../view/member/whitelist/uploadeindex')), reject, 'page-member') // 会员-白名单导入

const Shopmenu = (resolve, reject) => require.ensure([], () => resolve(require('../view/menus/shopmenu')), reject, 'page-menus') // 菜单管理

// import Regionauth from '../view/mall/liveroom/list' // 直播间列表
const Regionauth = (resolve, reject) => require.ensure([], () => resolve(require('../view/regionauth/list')), reject, 'page-regionauth') // 地区权限
const Openscreenad = (resolve, reject) => require.ensure([], () => resolve(require('../view/base/screen/openScreenAD')), reject, 'page-base') // 开屏广告
// import AfterServiceReason from
const Aftersalesreason = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/aftersales/reason')), reject, 'page-mall-aftersales') // 售后原因
//大屏
const Shopscreen_category = (resolve, reject) => require.ensure([], () => resolve(require('../view/shopscreen/category')), reject, 'page-shopscreen') // 自定义大屏分类
const BigScreenAd = (resolve, reject) => require.ensure([], () => resolve(require('../view/shopscreen/bigScreenAd')), reject, 'page-shopscreen') // 大屏广告
const HomeCarousel = (resolve, reject) => require.ensure([], () => resolve(require('../view/shopscreen/homeCarousel')), reject, 'page-shopscreen') // 轮播广告
const SearchKeyWords = (resolve, reject) => require.ensure([], () => resolve(require('../view/shopscreen/searchKeyWords')), reject, 'page-shopscreen') // 关键词设置
// 分账
const Setting = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/splitbill/setting')), reject, 'page-mall-splitbill') // 分账设置
const StoreFenSetting = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/splitbill/storesetting')), reject, 'page-mall-splitbill') // 分账设置

const StoreInformation = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/splitbill/list')), reject, 'page-mall-splitbill') // 分账进件列表

const StoreInformation_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/splitbill/edit')), reject, 'page-mall-splitbill') // 店铺认证信息录入
const StoreAccountingStatistics = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/splitbill/storeAccount')), reject, 'page-mall-splitbill') // 店铺分账统计
const PlatformAccountingStatistics = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/splitbill/platformAccount')), reject, 'page-mall-splitbill') // 平台分账统计

const ChannelPromotion = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/channelPromotion')), reject, 'page-mall-marketing') // 渠道推广列表
const ChannelPromotion_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/marketing/channelPromotionDetail')), reject, 'page-mall-marketing') // 渠道推广详情

const Coursegoods = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/course/CourseGoods')), reject, 'page-mall-goods') // 课程管理
const Coursegoods_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/course/CourseGoodsDetail')), reject, 'page-mall-goods') // 课程管理详情
const CourseAutogive = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/course/CourseAutogive')), reject, 'page-mall-goods')  // 课程赠送配置
const CourseAutogiveRecord = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/goods/course/CourseAutogiveRecord')), reject, 'page-mall-goods')  // 课程赠送记录

// 积分商城相关
const Pointsmallmaincategory = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/pointsmallgoods/maincategory')), reject, 'page-mall-pointsmallgoods') // 商品主类目
const Pointsmallcategory = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/pointsmallgoods/category')), reject, 'page-mall-pointsmallgoods') // 商品分类
const Pointsmallphysical = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/pointsmallgoods/physical/list')), reject, 'page-mall-pointsmallgoods') // 实体类商品
const Pointsmallphysical_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/pointsmallgoods/physical/add')), reject, 'page-mall-pointsmallgoods') // 实体类商品添加编辑
const Pointsmallphysical_editorCopy = (resolve, reject) => require.ensure([], () => resolve(require('../view/mall/pointsmallgoods/physical/addcopy')), reject, 'page-mall-pointsmallgoods') // 实体类商品添加编辑
// import Pointsmallattributes from '../view/mall/pointsmallgoods/attributes/attributes' // 商品规格列表
// import Pointsmallparams from '../view/mall/pointsmallgoods/attributes/params' // 商品参数列表
// import Pointsmallbrand from '../view/mall/pointsmallgoods/attributes/brand' // 商品品牌管理
// import Pointsmallphysicalupload from '../view/mall/pointsmallgoods/physical/normalGoodsUpload' // 实体商品导入
// import Pointsmallphysicalstoreupload from '../view/mall/pointsmallgoods/physical/normalGoodsStoreUpload' // 实体商品库存导入

// 商家功能
const SupplierManage = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/supplier_manage')), reject, 'page-supplier') // 商家管理
const SupplierManage_editor = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/supplier_manage_editor')), reject, 'page-supplier') // 商家编辑
const SupplierManage_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/supplier_manage_detail')), reject, 'page-supplier') // 商家入驻信息
const SupplierLaunchon = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/supplier_launchon')), reject, 'page-supplier') // 商家入驻审核
const SupplierLaunchon_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/supplier_launchon_detail')), reject, 'page-supplier') // 商家入驻审核详情
const AltmchApproval = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/joinpay/altmch_approval')), reject, 'page-supplier') // 商家汇聚分账进件审批功能
const AltmchApproval_detail = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/joinpay/altmch_approval_detail')), reject, 'page-supplier') // 商家汇聚分账进件审批功能
const AltSplitDetails = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/joinpay/alt_split_details')), reject, 'page-supplier') // 商家汇聚分账明细
const AltSettle = (resolve, reject) => require.ensure([], () => resolve(require('../view/supplier/joinpay/alt_settle')), reject, 'page-supplier') // 商家汇聚分账结算明细

export default {
  Home,
  Wxaindex,
  Layout,
  Authloading,
  Dashboard,
  Shopwxshop_editor,
  Shopwxshop,
  Wxshopsetting,
  Comments,
  Assetpayment,
  Assetaccountactivation,
  Datamessage,
  Staffleader,
  Accountmanagement,
  Accountroles,
  Basearticle,
  Basearticle_editor,
  Basecurrency,
  Baseexport,
  Brand,
  Brandcustomer,
  Brandmenu,
  Brandreply,
  Brandfans,
  Brandmaterial,
  Brandmaterial_editor,
  Goodscategory,
  Goodsmaincategory,
  Servicegoods,
  Courseresources,
  Servicegoods_editor,
  Goodsphysical,
  Goodsphysical_editor,
  Goodslease,
  Goodslease_editor,
  Goodsaudit,
  Goodsaudit_editor,
  Physicalupload,
  Tagsupload,
  Physicalstoreupload,
  Physicalprofitupload,
  Goodsbrand,
  Arrivalnotice,
  Servicepayment,
  Tradeservice,
  Tradenormalorders,
  Tradenormalshoporders,
  Leasetrade,
  Leasetrade_aftersales,
  Tradedrugorders,
  Tradepayment,
  Tradeverification,
  Tradenormalorders_detail,
  Tradenormalorders_process,
  Tradenormalshoporders_detail,
  Leasetrade_detail,
  Tradedrugorders_detail,
  Tradeservice_detail,
  Supplier,
  Shippingtemplates,
  Shippingtemplates_editor,
  Marketingdistributor,
  Marketingdistributor_editor,
  Marketingdistributor_template,
  Marketingdistribution_orders,
  Marketingdistribution_orders_detail,
  Distributortags,
  Distributorrel_items,
  Distributoraftersalesaddress,
  Distributorinvoice,
  Marketinglog,
  ShopDecoration,
  Marketingsalesman,
  Marketingsalesmanrole,
  ShoppingGuideTask,
  ShoppingGuideTask_statistics,
  Shoppingguidenotification,
  Shopnoticetempl,
  Salemancustomercomplaints,
  SalemanLoginHistory,
  Reservationsetting,
  Mallreservation,
  Mallreservation_editor,
  Reservationorder,
  Mallrecharge,
  Aftersaleslist,
  Aftersaleslist_detail,
  Aftersalesrefundlist,
  Aftersalesrefundlist_detail,
  Fapiaolist,
  Fapiaolist_detail,
  Fapiao_set,
  Fapiao_set_detail,
  Member,
  Member_detail,
  Manageinfomation,
  Managecard,
  Managecardorder,
  Managecustomer,
  MemberMerge,
  Managetag,
  Analysisrights,
  AnalysisrightsContent,
  Membermarketing,
  // Membermarketing_luckyDraw,
  CouponAutosend,
  Couponsend,
  Couponsend_detail,
  Smssend,
  Coupongive,
  Coupongive_detail,
  Coupongrantset,
  Membermarketing_detail,
  Marketingindex,
  // registerRromotionsAdd,
  Membermarketing_editor,
  Marketingbargain_editor,
  Marketingbargain,
  Marketingactivity,
  Marketingactivity_templ,
  Marketingactivity_editor,
  Marketingactivity_update,
  Goodslimit,
  Goodslimit_editor,
  Groupsindex,
  Groupsindex_editor,
  Groupsindex_detail,
  Groupsindex_team,
  Popularizesetting,
  Promotersetting,
  Popularizelist,
  Popularizeorder,
  Popularizepurchaseorder,
  Popularizepurchaseorder_detail,
  Popularizedata,
  Popularizelist_child,
  Popularizelist_stock,
  Popularizelist_incomeDetail,
  Popularizewithdraw,
  Popularizegoods,
  PopularizegoodsAudit,
  Taskbrokerage,
  Taskbrokeragecount,
  Popularizelist_detail,
  Marketingcommunity,
  Marketingcommunity_detail,
  Marketingcommunity_editor,
  Marketingcommunityactivity,
  Marketingcommunityactivity_editor,
  Marketingdeliveryorder,
  Marketingdeliveryorder_detail,
  Communitysetting,
  Communitywithdraw,
  Communityactivityorder,
  Communityactivityorder_detail,
  Marketingseckill,
  Marketingseckill_editor,
  Limitedtimesale,
  Limitedtimesale_editor,
  Wxapp,
  Wxapp_templ,
  Templateedit,
  Coursetemplate,
  Batemplateedit,
  Editcategory,
  Floorguide,
  Colorstyle,
  Cartremind,
  Membercentersetting,
  Itemsdetailsetting,
  OpenscreenadNew,
  Custompage,
  Customlink,
  Editdashboard,
  Editsourcemanagement,
  Editsourcemanagement_detail,
  Editauthorize,
  Marketingsfulldiscount,
  Marketingsfulldiscount_editor,
  Marketingpackage,
  Marketingpackage_editor,
  Marketingsfullminus,
  Marketingsfullminus_editor,
  Marketingsfullgift,
  Marketingsfullgift_editor,
  Marketingspluspricebuy,
  Marketingspluspricebuy_editor,
  Wheel,
  Retailer,
  Retailer_incomeDetail,
  Retailergoods,
  Retailerorders,
  Shopactivities,
  Shopactivities_editor,
  ShoppingGuideTask_editor,
  Shoppingguidenotification_editor,
  Ordersetting,
  Pctemplate,
  Pcviptemplate,
  Pcfootertext,
  Tdkglobalset,
  Tdkgivenset,
  Pccustompage,
  Shopexerp,
  Goodsattributes,
  Goodsparams,
  Storeshopitemanagement,
  Merchantstaff,
  Merchantstaffroles,
  Platformstaff,
  Platformstaffroles,
  Planting,
  Planting_editor,
  Articlecolumns,
  Articlegeneralcolumns,
  Playbackcolumns,
  Playback,
  Itemtags,
  Selfdeliveryaddress,
  // Distributoraftersalesaddress,
  Admininfo,
  Recommendlike,
  Omsqueuelog,
  Yilianyun,
  Tradesetting,
  Meiqia,
  Echat,
  Fapiaosetting,
  DistributorCode,
  // Onecode,
  // Things,
  // Batchs,
  // Thingsbatchsdetail,
  // Basic_setting,
  // Withdraw,
  // Surveillance,
  // Log,
  // Distributorlog,
  // List,
  Selformelementsetting,
  Selformelementsetting_editor,
  Selformtempsetting,
  Selformtempsetting_editor,
  Shopstorelist,
  Shopstorelist_editor,
  Companygoods,
  Memberstatistics,
  Orderstatistics,
  Hotkeywords,
  Goodsstatistics,
  Salesmonitoring,
  Salesmonitoring_editor,
  Operatorlogs,
  Logistics,

  Refunderrorlogs,
  Distributordata,
  Pointrule,
  Pointoverview,
  Noticemessage,
  Kdniao,
  Sfbsp,
  Rate,
  Physicalmeasurement,
  Physicalmeasurement_detail,
  Membertagcategory,
  Distributorshops,
  Distributorshops_editor,
  Workwechat,
  WorkwechatTagScript,
  WorkwechatTagScript_editor,
  WorkwechatTagScript_data,
  DistributionConfig,
  SalesmanRelationship,
  Certificate,
  Registrationactivity,
  Registrationactivity_editor,
  Registrationrecord,
  Registrationrecord_detail,
  Registrationrecord_editor,
  Profitlist,
  Specificcrowddiscount,
  Specificcrowddiscount_detail,
  Weburlsetting,
  Publicsetting,
  Sharesetting,
  Liveroomlist,
  Liveroomlist_editor,
  Liveroomlist_goodsstore,
  Laijianlivinglist,
  PosterActivity,
  LuckydrawProb,
  CheckinActivity,
  CheckinActivity_editor,
  Giftcard,
  Normalordersupload,
  AddressBook,
  Autorecharge,
  Autorechargerecord,
  // 跨境
  Origincountry,
  Crossbordersetinfo,
  Godsphysicalkj,
  Godsphysicalkj_editor,
  Taxstrategy,
  Taxstrategy_editor,
  DataAnalysis,
  Financialaftersaleslist,
  Salesreportlist,
  Salesorderslist,
  Whitelistlist,
  Whitelistuploade,
  // 菜单管理
  Shopmenu,
  // 地区权限
  Regionauth,
  // 开屏广告
  Openscreenad,
  Aftersalesreason,
  //大屏
  Shopscreen_category,
  BigScreenAd,
  HomeCarousel,
  SearchKeyWords,
  Setting,
  StoreInformation,
  StoreInformation_editor,
  StoreFenSetting,
  StoreAccountingStatistics,
  PlatformAccountingStatistics,
  ChannelPromotion,
  ChannelPromotion_editor,
  Coursegoods,
  Coursegoods_editor,
  CourseAutogive,
  CourseAutogiveRecord,
  Rankingrule,
  Rankingrule_editor,

  // 积分商城相关
  // Pointsmallmaincategory,
  // Pointsmallcategory,
  Pointsmallphysical,
  Pointsmallphysical_editor,
  Pointsmallphysical_editorCopy,
  // Pointsmallattributes,
  // Pointsmallparams,
  // Pointsmallbrand,
  // Pointsmallphysicalupload,
  // Pointsmallphysicalstoreupload,
  // Pointsmallsetting,
  // Templatesetting,
  // Pointsmallenormalorders,
  // Pointsmallenormalorders_detail,
  // Pointsmallrate,

  // 商家功能
  SupplierManage,
  SupplierManage_editor,
  SupplierManage_detail,
  SupplierLaunchon,
  SupplierLaunchon_detail,
  AltmchApproval,
  AltmchApproval_detail,
  AltSplitDetails,
  AltSettle
}

// 如果路由通过页面传值那么需要定义当前值的字段名称
export let routesParamsKey = {
  Shopstorelist_editor: 'wxShopId',
  WorkwechatTagScript_editor: 'id',
  WorkwechatTagScript_data: 'id',
  Goodsphysical_editor: 'itemId',
  Goodslease_editor: 'itemId',
  Coursegoods_editor: 'course_id',
  Godsphysicalkj_editor: 'itemId',
  Basearticle_editor: 'wxShopId',
  Brandmaterial_editor: 'media_id',
  Servicegoods_editor: 'itemId',
  Shippingtemplates_editor: 'templatesId',
  Marketingbargain_editor: 'bargain_id',
  Marketingactivity_editor: 'type',
  Groupsindex_editor: 'groups_id',
  Groupsindex_detail: 'team_id',
  Groupsindex_team: 'groups_id',
  Marketingcommunity_editor: 'community_id',
  Marketingcommunityactivity_editor: 'activity_id',
  Marketingseckill_editor: 'seckill_id',
  Limitedtimesale_editor: 'seckill_id',
  Marketingdeliveryorder_detail: 'delivery_id',
  Marketingsfulldiscount_editor: 'marketing_id',
  Marketingsfullminus_editor: 'marketing_id',
  Marketingsfullgift_editor: 'marketing_id',
  Marketingspluspricebuy_editor: 'marketing_id',
  Planting_editor: 'marketing_id',
  Shopwxshop_editor: 'wxShopId',
  Marketingpackage_editor: 'package_id',
  Goodslimit_editor: 'limit_id',
  ShopActivities_editor: 'item_id',
  ShoppingGuideTask_editor: 'task_id',
  Shoppingguidenotification_editor: 'id',
  Taxstrategy_editor: 'id',
  StoreInformation_editor: 'id',
  Liveroomlist_editor: 'tutor_id',
  Pointsmallphysical_editor: 'itemId',
  Rankingrule_editor: 'id',
  CheckinActivity_editor: 'id',
  SupplierManage_editor: 'sp_id',
  SupplierManage_detail: 'sp_id',
  SupplierLaunchon_detail: 'apply_id',
  AltmchApproval_detail: 'joinpay_altmch_id',
}



// WEBPACK FOOTER //
// ./src/router/routers.js